import PVChart from '../../common/pv-chart'

$(() => {
  if (!$('#owner-users_show').length) {
    return
  }

  new PVChart($('#pv'))
})